export default {
  masterChef: {
    64668: '0xa7b37d6abe333e85b49dec00029517746bbb8fff',
	3797: '0xa7b37d6abe333e85b49dec00029517746bbb8fff',
  },
  sousChef: {
    64668: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    3797: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    64668: '0x96aadb2977ac505fbf6dbdd0e79dc0a998dc25ce',
    3797: '0x7ea9b4d1d87611b17f90a3543c0a2d0b4269ca10',
  },
  multiCall: {
    3797: '0x949d1a0757803c51f2efffeb5472c861a898b8e8',
    64668: '0x949d1a0757803c51f2efffeb5472c861a898b8e8',
  },
  pancakeProfile: {
    3797: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    64668: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    3797: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    64668: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    3797: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    64668: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    3797: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    64668: '',
  },
  pointCenterIfo: {
    3797: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    64668: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    3797: '0xFee8A195570a18461146F401d6033f5ab3380849',
    64668: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    3797: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    64668: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    3797: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    64668: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    3797: '0x946cb8b809a691433518c99bedd11357daa7e494',
    64668: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
  },
  predictions: {
    3797: '0xe7C277DB56F2089351E9ac910871EB820e11206B',
    64668: '',
  },
  chainlinkOracle: {
    3797: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    64668: '',
  },
  bunnySpecialCakeVault: {
    3797: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    64668: '',
  },
  bunnySpecialPrediction: {
    3797: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    64668: '',
  },
  bunnySpecialLottery: {
    3797: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    64668: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    3797: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    64668: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
}
